// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { CommissionItem } from "./CommissionItem.js";
import { RevenueCommissionType } from "../../../Utils/Enums/Constants.js";

export let CommissionPlan = function (dCache)
{
    this.DCache = dCache;

    this.Id = null;
    this.Name = null;
    this.Description = null;

    this.CommisionForTransfer = null;

    this.CounterAccountID = null;

    this.TransferCommisionType = RevenueCommissionType.None;
    this.WithdrawalCommisionType = RevenueCommissionType.None;

    this.TransferPercentage = null;
    this.WithdrawalPercentage = null;
    this.TransferFixedFee = null;
    this.WithdrawalFixedFee = null;
    this.TransferMinFee = null;
    this.WithdrawalMinFee = null;
    this.TransferMaxFee = null;
    this.WithdrawalMaxFee = null;
    this.TransferCurrencyId = null;
    this.WithdrawalCurrencyId = null;
    this.TransferAccountId = null;
    this.WithdrawalAccountId = null;

    this._itemsByInstrumentId = new Object();
    this._itemsByType = new Object();
    this._defaultCommissionItem = null;
    this._itemsByInstrumentIdHasValue = false;
    this._itemsByTypeHasValue = false;
}

CommissionPlan.prototype.Update = function (msg)
{
    this.Id = msg.Id
    this.Name = msg.Name
    this.Description = msg.Description
    this.CommisionForTransfer = msg.CommisionForTransfer
    this.CounterAccountID = msg.CounterAccountID

    this.TransferCommisionType = msg.TransferCommisionType
    this.WithdrawalCommisionType = msg.WithdrawalCommisionType

    this.TransferPercentage = msg.TransferPercentage
    this.WithdrawalPercentage = msg.WithdrawalPercentage
    this.TransferFixedFee = msg.TransferFixedFee
    this.WithdrawalFixedFee = msg.WithdrawalFixedFee
    this.TransferMinFee = msg.TransferMinFee
    this.WithdrawalMinFee = msg.WithdrawalMinFee
    this.TransferMaxFee = msg.TransferMaxFee
    this.WithdrawalMaxFee = msg.WithdrawalMaxFee

    this.TransferCurrencyId = msg.TransferCurrencyId
    this.WithdrawalCurrencyId = msg.WithdrawalCurrencyId
    this.TransferAccountId = msg.TransferAccountId
    this.WithdrawalAccountId = msg.WithdrawalAccountId

    this._itemsByInstrumentId = new Object()
    this._itemsByType = new Object()
    this._defaultCommissionItem = null
    this._itemsByInstrumentIdHasValue = this._itemsByTypeHasValue = false

    let items = msg.CommissionItems
    for (let i = 0; i < items.length; i++)
        this.AddItem(items[i]);
}

CommissionPlan.prototype.AddItem = function (data)
{
    let item = new CommissionItem(data),
        insID = data.InstrumentId,
        insTypeID = data.InstrumentTypeId
    if (insID)
    {
        if (!this._itemsByInstrumentId[insID])
            this._itemsByInstrumentId[insID] = item
        else
            this._itemsByInstrumentId[insID].Add(data)

        this._itemsByInstrumentIdHasValue = true;
    }
    else if (insTypeID !== -1)
    {
        if (!this._itemsByType[insTypeID])
            this._itemsByType[insTypeID] = item
        else
            this._itemsByType[insTypeID].Add(data)

        this._itemsByTypeHasValue = true;
    }
    else
    {
        if (!this._defaultCommissionItem)
            this._defaultCommissionItem = item
        else
            this._defaultCommissionItem.Add(data);
    }
}

CommissionPlan.prototype.GetCommissionItem = function (instrument)            // получение CommissionItem по инструменту
{
    if (!instrument)
        return null;

    let item = this._itemsByInstrumentId[instrument.Id];
    if (item)
        return item;

    let typeID = instrument.TypeId
    while (typeID != -1)
    {
        item = this._itemsByType[typeID]
        if (item)
            return item

        let insType = this.DCache.getInstrumentTypeById(typeID)
        typeID = insType != null ? insType.SuperTypeId : -1                     // поищем определяющий CommissionItem в инстр.группах-предках, пока не упремся в корневую
    }

    return this._defaultCommissionItem;
}

// CommissionPlan.prototype.IsZero = function ()
// {
//     return !this._itemsByInstrumentIdHasValue && !this._itemsByTypeHasValue && this._defaultCommissionItem.InstrumentGroupId === null && this._defaultCommissionItem.InstrumentId === "";
// }

CommissionPlan.prototype.AddFeeItems = function (itemsForTable, ins)
{
    let item = this.GetCommissionItem(ins)

    if (item)
        item.AddFeeItems(itemsForTable)
}

CommissionPlan.prototype.GetAllowedCommissionTypes = function (ins)
{
    let it = this.GetCommissionItem(ins);
    let res = {};
    if (!it)
        return res;
    for (let i = 0; i < it.Entry.length; i++)
    {
        let ent = it.Entry[i];
        let ci = ent.CommissionItems;
        for (let j = 0; j < ci.length; j++)
            res[ci[j].Type] = true;
    }
    return res;
}

CommissionPlan.TryGetCommissionDataValue = function (feeCurrency, key, instrument, account)
{
    if (!account || !account.CommissionPlan) return null

    let commissionItem = account.CommissionPlan.GetCommissionItem(instrument);
    if (!commissionItem) return null;

    return commissionItem.GetCommissionDataValue(feeCurrency, key);
}

